import { render, staticRenderFns } from "./addAds.vue?vue&type=template&id=4f1e7626&scoped=true&"
import script from "./addAds.vue?vue&type=script&lang=ts&"
export * from "./addAds.vue?vue&type=script&lang=ts&"
import style0 from "./addAds.vue?vue&type=style&index=0&id=4f1e7626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e7626",
  null
  
)

export default component.exports